(ns ductile.ui.forms
  (:require #?@(:cljs [[clojure.set :refer [rename-keys]]
                       [ductile.ui.components :as ui]
                       [ductile.ui.components.combobox :as combobox]
                       [inside-out.forms :as forms]
                       [inside-out.util :as util :refer [merge-props]]
                       [reagent.core :as r]])
            [ductile.ui.locale :as locale]))

(def attr-or-path->text
  ;; TODO: Unify with locale keys
  (merge locale/translated-keys
         {:fahrzeug "Compound vehicle"
          :parking-spot "Parking spot"
          :fahrzeug/call-off-datetime "Call-Off datetime"
          :ars/id "ARS-ID"
          :compound/name "Compound"
          :color/description "Color description"
          :parking-zone/name "Parking spot"
          :vehicle/vin "VIN"
          :fahrzeug/vehicle "Vehicle"
          :vehicle/model-info "Model info"
          :entry/expected-datetime "Expected entry datetime"
          :entry/datetime "Entry datetime"
          :fahrzeug/expected-customer-delivery-datetime "Expected customer delivery date"
          :entry/mode "Entry mode"
          :exit-transport/transport-mode "Transport Mode (Exit)"
          :entry-transport-order/external.bmw-carrier-code "Entry transport order carrier code"
          :entry-transport-order/external.bmw-spediteur "Entry transport order spediteur"
          :entry-transport-order/origin-location-location-name "Entry transport order origin location"
          :entry-transport-order/transport-mode "Entry transport order mode"
          :entry-transport-order/transport-order-load-number "Entry transport order load number"
          :exit-transport/transport-name "Exit transport name"
          :exit-transport-order/origin-location-compound-name "Exit transport order origin compound"
          :exit-transport-order/destination-location-address-name "Exit transport order destination location"
          :exit-transport-order/destination-location-address-street "Exit transport order destination address"
          :exit-transport-order/destination-location-address-city "Exit transport order destination city"
          :exit-transport-order/destination-location-address-province-code "Exit transport order destination province"
          :exit-transport-order/destination-location-address-region "Exit transport order destination region"
          :exit-transport-order/destination-location-location-name "Exit transport order destination location"
          :exit-transport-order/external.bmw-carrier-code "Exit transport order carrier code"
          :exit-transport-order/external.bmw-spediteur "Exit transport order spediteur"
          :exit-transport-order/transport-mode "Exit transport order mode"
          :external.bmw/color-code "BMW color code"
          :external.bmw/model-code "Model code"
          :ductile/id "Ductile ID"
          :vehicle/blocks "Blocked"
          :fahrzeug/customer "Customer"
          :customer/name "Customer"
          :transport/mode "Transport mode"
          :transport/name "Transport name"
          :entry/transport "Entry transport"
          :entry/transport-order "Entry transport order"
          :entry-transport/transport-name "Entry transport name"
          :exit/datetime "Exit datetime"
          :exit/transport "Exit transport"
          :exit/transport-order "Exit transport order"
          :exit/expected-datetime "Exit expected at"
          :fahrzeug/delivery-dealer-code-raw "Delivery dealer code"
          :storage/entry-datetime "Storage entry at"
          :storage/exit-datetime "Storage exit at"
          :fahrzeug/order-number "Order number"
          :exit-transport-order/transport-name "Exit transport order name"
          :external.bmw/carrier-code "Carrier code"
          :external.bmw/spediteur "Spediteur"
          :destination/location "Destination"
          :origin/location "Origin"
          :fahrzeug/damaged? "Damaged"
          :fahrzeug/damages "Damaged"
          :fahrzeug/customs-number "Customs number"
          :transport/load-number "Transport load number"
          :vehicle/color "Color"
          :vehicle/model "Model"
          :make/name "Make"
          :fuel/type "Fuel type"
          :vehicle/drivable? "Drivable"
          :vehicle/engine-type "Engine type"
          :vehicle/volume "Volume"
          :vehicle/weight "Weight"
          :vehicle/dimensions "Dimensions"
          :vehicle/height-mm "Height"
          :vehicle/width-mm "Width"
          :vehicle/length-mm "Length"
          :vehicle/make "Make"
          :vehicle/new? "New?"
          :workflow/code "Workflow"
          :contract/description "Contract"
          :ductile/comments "Comments"
          :fahrzeug/available-workflows "Available workflows"
          :fahrzeug/customs-clearance "Customs clearance"}))

(defn attr->text [attr]
  (cond
    (string? attr)
    attr
    (keyword? attr)
    (get attr-or-path->text attr (str attr))
    :else
    (loop [path attr]
      (cond (= 0 (count path))
            (str attr)
            (= 1 (count path))
            (get attr-or-path->text (first path) (str attr))
            :else
            (if-let [text (get attr-or-path->text path)]
              text
              (recur (rest path)))))))

#_(attr->text [:entry/transport-order :destination/location :compound/name])

(def invalid-text-color "text-red-500 ")

(defn view-message [{:keys [type content]}]
  (let [content* (if (string? content)
                   (locale/tr content)
                   content)]
    [:div.text-xs.p-1.mt-1.rounded-sm
     {:class (case type
               (:error :invalid) invalid-text-color
               nil)}
     content*]))

#?(:cljs
   (defn input-text
     "A text-input element that reads metadata from a ?field to display appropriately"
     [?field attrs]
     (let [messages (forms/visible-messages ?field)]
       [:<>
        [ui/input
         (merge-props {:placeholder (:label ?field)
                       :value @?field
                       :on-input (comp (fn [& _] (r/flush))
                                       (forms/change-handler ?field))
                       :on-blur (forms/blur-handler ?field)
                       :on-focus (forms/focus-handler ?field)
                       :class (when (:invalid (forms/types messages))
                                "ring-2 ring-offset-2 ring-red-500 focus:ring-red-500 rounded")
                       :size 3}
                      attrs)]
        (when (seq messages)
          (into [:div.mt-1] (map view-message) messages))])))

#?(:cljs
   (defn combo-box
     "A text-input element that reads metadata from a ?field to display appropriately"
     [?field attrs]
     (let [messages (forms/visible-messages ?field)
           ;; convert options to js here, so that we can pass
           ;; the matching one as :value
           choices (map #(rename-keys % {:value :ui/value
                                         :label :ui/label}) (:options attrs))
           value (util/first-when #(= @?field (:ui/value %)) choices)]
       [:<>
        [combobox/view
         (merge-props {:placeholder (:label ?field)
                       :on-change #(reset! ?field (:ui/value %))
                       :on-blur (forms/blur-handler ?field)
                       :on-focus (forms/focus-handler ?field)
                       :class (when (:invalid (forms/types messages))
                                "ring-2 ring-offset-2 ring-red-500 focus:ring-red-500 rounded-md")
                       :choices choices
                       :value value
                       :size 3}
                      (dissoc attrs))]
        (into [:div.mt-1] (map view-message) messages)])))
